import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface PricingSectionProps {
  isExpired: boolean;
}
export function PricingSection({
  isExpired
}: PricingSectionProps) {
  const price = isExpired ? '$47.00' : '$6.36';
  return <section id="pricing" className="py-12 px-4 bg-dark" data-id="element-206">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-207">
        <div className="bg-dark-100 border border-gold/30 rounded-xl p-6 md:p-8" data-id="element-208">
          <p className="text-base text-sub mb-2" data-id="element-209">
            Valor Total del Sistema:{' '}
            <span className="line-through decoration-urgency-text decoration-2" data-id="element-210">
              $127.00
            </span>
          </p>

          <p className="text-base text-sub mb-4" data-id="element-211">
            Precio Regular:{' '}
            <span className="line-through decoration-urgency-text decoration-2" data-id="element-212">
              $47.00
            </span>
          </p>

          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-2" data-id="element-213">
            ENTRA AL PROTOCOLO HOY POR:
          </h2>

          <p className="text-5xl md:text-6xl font-bold mb-6" style={{
          color: '#10B981'
        }} data-id="element-214">
            {price}
          </p>

          <p className="text-sm text-sub mb-6 max-w-[520px] mx-auto" data-id="element-215">
            Nuestra misión es que este protocolo llegue a quien lo necesita. Por
            eso bajamos la barrera de entrada para que el precio nunca sea la
            excusa para seguir viviendo en el caos.
          </p>

          <a href="https://pay.hotmart.com/J105033112F?off=ubpybkik" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-hover text-dark font-bold uppercase font-serif text-base py-[18px] px-9 rounded-md transition-colors shadow-[0_4px_20px_rgba(201,168,76,0.3)] hover:shadow-[0_4px_24px_rgba(201,168,76,0.4)] w-full md:w-auto" data-id="element-216">
            <span data-id="element-217">SÍ, ESTOY LISTO PARA MI RESET</span>
            <ArrowRightIcon className="w-5 h-5" data-id="element-218" />
          </a>

          {!isExpired && <p className="text-urgency-text text-sm font-semibold mt-6" data-id="element-219">
              El precio subirá a $47.00 cuando el contador llegue a cero.
            </p>}
        </div>
      </div>
    </section>;
}